import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../config/apiConfig";
import PageHeader from "../../components/pageHeader";
import MainContentLayout from "../../components/mainContentLayout";
import LoadingOverlay from "../../components/loadingOverlay";
import { FaUserCircle } from "react-icons/fa";

export default function IndividualProfilesPage() {
  const token = sessionStorage.getItem("access_token");
  const navigate = useNavigate();

  const [players, setPlayers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------------------
  // LOAD PLAYERS FROM BACKEND
  // ------------------------------------------------------------
  useEffect(() => {
    loadPlayers();
  }, []);

  async function loadPlayers() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/performance-players`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (data.success) {
        const sorted = data.players.sort((a, b) =>
          a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase())
        );
        setPlayers(sorted);
      }
    } finally {
      setLoading(false);
    }
  }

  // ------------------------------------------------------------
  // LOCAL SEARCH
  // ------------------------------------------------------------
  const filteredPlayers = players.filter((p) =>
    p.fullName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <MainContentLayout>
      <LoadingOverlay show={loading} />

      {/* Header */}
      <PageHeader
        title="Individual Profiles"
        backTo="/admin-performance-review-landing"
      />

      {/* Search bar */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search players..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border px-3 py-2 rounded w-full md:w-1/2 placeholder:italic placeholder:text-gray-400"
        />
      </div>

      {/* Player Grid */}
      {filteredPlayers.length === 0 ? (
        <p className="text-gray-500">No players found.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {filteredPlayers.map((player) => (
            <div
              key={player.id}
              onClick={() => navigate(`/performance-review/${player.id}`)}
              className="cursor-pointer bg-white border rounded-xl shadow-md p-4 flex flex-col items-center hover:shadow-lg transition"
            >
              {/* Avatar */}
              {player.photo ? (
                <img
                  src={player.photo}
                  alt="Avatar"
                  className="w-24 h-24 rounded-full border object-cover mb-2"
                />
              ) : (
                <FaUserCircle className="w-24 h-24 text-gray-400 mb-2" />
              )}

              {/* Name */}
              <p className="text-center font-medium">{player.fullName}</p>
            </div>
          ))}
        </div>
      )}
    </MainContentLayout>
  );
}
